import { useContext, useEffect } from 'react'
import { addHours, parseISO } from 'date-fns'
import { EventsCalendarContext } from './context'
import EventsCalendarDay from './EventsCalendarDay'
import EventsCalendarList from './EventsCalendarList'

export function EventsCalendarView({
  events,
  headerLocation,
  handleUpdateSearch,
  selectedDate,
  setSelectedDate,
  tab,
  setTab,
  hideOptionList,
}) {
  const { eventsMode, setEventsMode } = useContext(EventsCalendarContext)

  useEffect(() => {
    if (hideOptionList && eventsMode === 'Lista')
        setEventsMode('Dia')
  }, [eventsMode])

  const formattedEvents = events?.map((item) => ({
    id: item.id || item.id,
    title: [item?.organs?.[0]?.initials, item.type || item.openDataResource.toUpperCase()].filter(i => !!i).join(" - "),
    start: parseISO(item.dateStart),
    end: addHours(parseISO(item.dateStart), 1),
    event: item,
    background: item.background,
    borderColor: item.borderColor
  })) || []

  const components = {
    Dia: <EventsCalendarDay
      data={formattedEvents}
      headerLocation={headerLocation}
      handleUpdateSearch={handleUpdateSearch}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      tab={tab}
      setTab={setTab}
      hideOptionList={hideOptionList}
    />,
    Lista: hideOptionList ? null : <EventsCalendarList
      data={events}
      headerLocation={headerLocation}
      handleUpdateSearch={handleUpdateSearch}
      tab={tab}
      setTab={setTab}
    />,
  }

  return (
    <>
      {components[eventsMode]}
    </>
  )
}